export default __webpack_public_path__ + "static/media/Website images-10.148fe73f.jpg";